import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../services/auth.service';
import { OverlayService } from '../../../services/overlay.service';
import { CreatorFrontApi } from '../../../services/component.service';
import { NewApiHttpService, NewApiResponse } from '../../../services/new-api-http.service';
import { Subscription } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { BeeFreeService } from '../../../services/beefree.service';

@Component({
	selector: 'app-top-menu',
	templateUrl: './top-menu.component.html',
	styleUrls: ['./top-menu.component.scss'],
	providers: [AuthService]
})
export class TopMenuComponent implements OnInit, OnDestroy {
	@ViewChild('changePasswordModal', { static: true }) changePasswordModal;
	user: any;
	environment = environment.production;
	userEmail: string;
	sending: boolean;
	sentOk: boolean;
	isAdmin: boolean;
	workingAs: boolean;
	userSubscription: Subscription;
	isBeeFree: boolean;
	toastDisplay = false;

	constructor(
		private newApiHttpService: NewApiHttpService,
		public auth: AuthService,
		private overlay: OverlayService,
		private ref: ChangeDetectorRef,
		private beeFree: BeeFreeService
	) {
		this.resetUserConfig();
	}

	ngOnInit(): void {
		this.userSubscription = this.auth
			.getUserObservable()
			.pipe(
				filter((user) => !!user),
				map((user) => JSON.parse(atob(decodeURIComponent(user))))
			)
			.subscribe(
				(user) => {
					this.user = user;
					this.getUserConfig();
					this.ref.detectChanges();
				},
				(error) => console.log('Creator Error:', error),
				() => {}
			);

		this.isBeeFree = this.beeFree.isBeeFreeAddon();
	}

	ngOnDestroy(): void {
		this.userSubscription.unsubscribe();
	}

	getUserConfig(): void {
		this.userEmail = this.getEmail();
		this.isAdmin = this.isUserAdmin();
		this.workingAs = this.isWorkingAs();
	}

	getEmail(): string {
		const origUserEmail = this.user && this.user.originalUser ? this.user.originalUser.email : null;
		const userEmail = this.user && this.user.email;
		return this.user ? origUserEmail || userEmail : null;
	}

	isUserAdmin(): boolean {
		return this.auth.isAdmin();
	}

	isWorkingAs(): boolean {
		return Boolean(this.user && this.user.workingAs === true);
	}

	resetUserConfig() {
		this.userEmail = '';
		this.sending = false;
		this.sentOk = false;
		this.isAdmin = false;
		this.workingAs = false;
	}

	logout(): void {
		this.auth.logout();
		this.user = null;
		this.resetUserConfig();
	}

	submitSupportForm(values): void {
		this.sending = true;

		const message = `<br><br><br><br>
    <table style="width:50%; border:1px solid #4f5254; color:#4f5254;" cellspacing="0" cellpadding="0">
        <tr>
            <th style="width:50%; border:1px solid #4f5254; color:#4f5254; padding: 10px; text-align: left">Name:</th>
            <td style="width:50%; border:1px solid #4f5254; color:#4f5254;padding: 10px;">${values.formSupportName}</td>
        </tr>
        <tr>
            <th style="width:50%; border:1px solid #4f5254; color:#4f5254; padding: 10px; text-align: left">Email:</th>
            <td style="width:50%; border:1px solid #4f5254; padding: 10px;color:#4f5254;">
              <a href="mailto:${values.formSupportEmail}">${values.formSupportEmail}</a>
            </td>
        </tr>
        <tr>
            <th style="width:50%; border:1px solid #4f5254; color:#4f5254; padding: 10px; text-align: left">Account:</th>
            <td style="width:50%; border:1px solid #4f5254; color:#4f5254;padding: 10px;">${this.user.email}</td>
        </tr>
        <tr>
            <th style="width:50%; border:1px solid #4f5254; padding: 10px;color:#4f5254; text-align: left">Comment:</th>
            <td style="width:50%; border:1px solid #4f5254; padding: 10px;color:#4f5254;">${values.comment}</td>
        </tr>
        <tr>
            <th style="width:50%; border:1px solid #4f5254; padding: 10px;color:#4f5254; text-align: left">Submission time:</th>
            <td style="width:50%; border:1px solid #4f5254; padding: 10px;color:#4f5254;">${new Date()}</td>
        </tr>
    </table>
    `;

		const data = {
			to: 'dmsupport@optimove.com',
			subject: 'Support Request From ' + values.formSupportEmail,
			html: message,
			from: values.formSupportEmail
		};

		this.newApiHttpService.newApiRequestPost('support', data).subscribe(
			(response: NewApiResponse) => {
				if (response && response.status) {
					this.sentOk = true;
				}
			},
			(error) => this.overlay.updateOverlay(true, error, 'alert')
		);
	}

	getErrorStringFromResponse(response: CreatorFrontApi): string {
		let errorString = '';
		if (typeof response.reason !== 'undefined') {
			errorString = response.reason;
		} else if (typeof response.error !== 'undefined') {
			errorString = response.error;
		}
		return errorString;
	}

	submitChangePasswordFormForm(values): void {
		this.changePasswordModal.hide();
		const newAPIData = { user_id: this.user.userId, old_password: values.Old_Password.trim(), password: values.New_Password.trim() };
		const hasMoreThanAscii = values.New_Password.trim()
			.split('')
			.some(function (char) {
				return char.charCodeAt(0) > 127;
			});

		if (hasMoreThanAscii) {
			// string has non-ascii characters
			this.overlay.updateOverlay(true, 'New Password should contain only characters A-Z, 0-9, and simple symbols', 'alert');
			return;
		}

		this.newApiHttpService.newApiRequestPut('user/reset-password', newAPIData).subscribe(
			(response: NewApiResponse) => {
				if (!response || !response.status) {
					this.overlay.updateOverlay(true, `Reset password failed. ${response.message}`, 'alert');
				} else if (response.status) {
					this.overlay.updateOverlay(true, 'Your account password has been changed.', 'alert');
				}
			},
			(error) => this.overlay.updateOverlay(true, error, 'alert'),
			() => {}
		);
	}

	cancelBeeFree() {
		this.beeFree.cancelAddon();
	}

	hideToast() {
		this.toastDisplay = false;
	}
}
